import React, { useState } from "react";

import FollowUpDashboard from "../Dashboard/FollowUpDashboard";
import RecoveryDashboard from "../Dashboard/RecoveryDashboard";
import RecoveryUpcomingSchedules from "../Dashboard/RecoveryUpcomingSchedules";
import RecoveryManualCanceledCard from "../Dashboard/RecoveryManualCanceledCard";
import LeadScoreDashboard from "../Dashboard/LeadScoreDashboard";

const tabs = [
  { key: "followups", label: "Follow-ups", component: <FollowUpDashboard /> },
  { key: "recovery", label: "Régua de Recuperação", component: <RecoveryDashboard /> },
  { key: "upcoming", label: "Próximos disparos", component: <RecoveryUpcomingSchedules /> },
  { key: "canceled", label: "Cancelados manualmente", component: <RecoveryManualCanceledCard /> },
  { key: "score", label: "Score de Leads", component: <LeadScoreDashboard /> }
];

const RecoveryFollowUp = () => {
  const [activeTab, setActiveTab] = useState("followups");
  const currentTab = tabs.find(tab => tab.key === activeTab) || tabs[0];

  return (
    <div style={{ padding: 24 }}>
      <div
        style={{
          background: "linear-gradient(135deg, #111827, #dc2626)",
          borderRadius: 18,
          padding: 24,
          color: "#fff",
          marginBottom: 20
        }}
      >
        <div style={{ fontSize: 13, fontWeight: 800, opacity: 0.85 }}>
          Operação Comercial
        </div>

        <h1 style={{ margin: "6px 0 8px", fontSize: 30 }}>
          Follow-up Inteligente
        </h1>

        <div style={{ fontSize: 14, opacity: 0.9 }}>
          Controle de follow-ups, régua de recuperação, próximos disparos, cancelamentos e priorização de leads.
        </div>
      </div>

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 18 }}>
        {tabs.map(tab => {
          const selected = tab.key === activeTab;

          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => setActiveTab(tab.key)}
              style={{
                border: 0,
                borderRadius: 999,
                padding: "10px 16px",
                background: selected ? "#dc2626" : "#f1f5f9",
                color: selected ? "#fff" : "#334155",
                fontWeight: 900,
                cursor: "pointer"
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {currentTab.component}
    </div>
  );
};

export default RecoveryFollowUp;
